import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'earbuds',
  size: 24,
  node: [
    [
      'path',
      {
        d: 'M18 3a4 4 90 00-4 4v12a2 2 90 004 0v-8a5 5 90 003.75-1.693 1 1 90 00.25-.661V5.354a1 1 90 00-.25-.661A5 5 90 0018 3',
        key: '11kxgw',
      },
    ],
    [
      'path',
      {
        d: 'M6 3a4 4 0 014 4v12a2 2 0 01-4 0v-8a5 5 0 01-3.75-1.693A1 1 0 012 8.646V5.354a1 1 0 01.25-.661A5 5 0 016 3',
        key: '14gtst',
      },
    ],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name Earbuds
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTggM2E0IDQgOTAgMDAtNCA0djEyYTIgMiA5MCAwMDQgMHYtOGE1IDUgOTAgMDAzLjc1LTEuNjkzIDEgMSA5MCAwMC4yNS0uNjYxVjUuMzU0YTEgMSA5MCAwMC0uMjUtLjY2MUE1IDUgOTAgMDAxOCAzIiAvPgogIDxwYXRoIGQ9Ik02IDNhNCA0IDAgMDE0IDR2MTJhMiAyIDAgMDEtNCAwdi04YTUgNSAwIDAxLTMuNzUtMS42OTNBMSAxIDAgMDEyIDguNjQ2VjUuMzU0YTEgMSAwIDAxLjI1LS42NjFBNSA1IDAgMDE2IDMiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/earbuds
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Earbuds = createLucideIcon(__iconData);

export default Earbuds;
